import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './modules/types'
import { components } from './modules/components'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    locale: 'zh',
    username: '',
    memberId: 0,
    avatar: '',
    roleType: '',
    fileUploadProgress: {},
    forceBack: false,
  },
  getters: {
    getProgress: state => {
      return state.fileUploadProgress
    },
  },
  mutations: {
    changeLocale(state, payload: string) {
      state.locale = payload
    },
    setRoleType(state, payload: string) {
      state.roleType = payload
    },
    setUserInfo(state, payload: { username: string; memberId: number; avatar: string }) {
      const { username, avatar, memberId } = payload
      state.username = username
      state.memberId = memberId
      state.avatar = avatar
    },
    setFileUploadProgress(state, payload: { key: string; progress: number }) {
      const { key, progress } = payload
      Vue.set(state.fileUploadProgress, key, progress)
    },
    changeForceBack(state, payload: boolean) {
      state.forceBack = payload
    },
  },
  modules: {
    components,
  },
}

export default new Vuex.Store<RootState>(store)
